/**
 * COLLECTIONS EXPLORER - IntersectionObserver Version
 * Sin dependencias externas. Controla el highlight y el botón activo.
 */

(function() {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Set active state on nav + button
   */
  function setActive(wrapper, navItems, discoverButton, idx) {
    var activeColor = (getComputedStyle(wrapper).getPropertyValue('--collections-nav-active-color') || '#ffffff').trim() || '#ffffff';
    var inactiveColor = (getComputedStyle(wrapper).getPropertyValue('--collections-nav-inactive-color') || '#ffffff').trim() || '#ffffff';
    var activeOpacity = parseFloat(getComputedStyle(wrapper).getPropertyValue('--collections-nav-active-opacity')) || 1;
    var inactiveOpacity = parseFloat(getComputedStyle(wrapper).getPropertyValue('--collections-nav-inactive-opacity')) || 1;

    navItems.forEach(function(item, i) {
      var nameEl = item.querySelector('.collection-nav-name');
      if (!nameEl) return;

      if (i === idx) {
        item.classList.add('active');
        nameEl.style.color = activeColor;
        nameEl.style.opacity = activeOpacity;
        if (discoverButton) {
          var href = item.getAttribute('href');
          if (href) discoverButton.href = href;
        }
      } else {
        item.classList.remove('active');
        nameEl.style.color = inactiveColor;
        nameEl.style.opacity = inactiveOpacity;
      }
    });
  }

  /**
   * Video playback control: pause offscreen, play onscreen
   */
  function handleVideoPlayback(sections) {
    if (prefersReducedMotion) {
      sections.forEach(function(section) {
        var video = section.querySelector('.collection-bg-video');
        if (video) {
          try { video.pause(); } catch (e) {}
        }
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target.querySelector('.collection-bg-video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(function() {});
        } else {
          try { video.pause(); } catch (e) {}
        }
      });
    }, { threshold: 0.5 });

    sections.forEach(function(section) { observer.observe(section); });
  }

  /**
   * Initialize one instance
   */
  function initCollectionsExplorer(sectionId) {
    var wrapper = document.getElementById('collections-explorer-' + sectionId);
    if (!wrapper) return;

    var sections = Array.from(wrapper.querySelectorAll('.collection-scroll-section'));
    var navItems = Array.from(wrapper.querySelectorAll('.collection-nav-item'));
    var discoverButton = wrapper.querySelector('.discover-button');
    var navElement = wrapper.querySelector('.collections-nav-fixed');
    var headerElement = wrapper.querySelector('.collections-explorer-header');
    var lastActiveIndex = 0;
    var lastClickedIndex = null; // Track to allow navigation only on a second click
    var navTargets = [navElement, headerElement].filter(Boolean);
    var navObserver = null;
    var bottomObserver = null;
    var bottomSentinel = document.createElement('div');
    bottomSentinel.className = 'collections-explorer-bottom-sentinel';
    bottomSentinel.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(bottomSentinel);

    if (!sections.length || !navItems.length) return;

    function setNavVisibility(inView) {
      navTargets.forEach(function(el) {
        el.style.opacity = inView ? '1' : '0';
        el.style.visibility = inView ? 'visible' : 'hidden';
      });
    }

    // Initial nav visibility
    (function initNavVisibility() {
      if (!navTargets.length) return;
      var rect = wrapper.getBoundingClientRect();
      var inView = rect.bottom > 0 && rect.top < window.innerHeight;
      setNavVisibility(inView);
    })();

    // Initial state
    setActive(wrapper, navItems, discoverButton, 0);

    // Smooth scroll on click
    navItems.forEach(function(item, index) {
      item.addEventListener('click', function(e) {
        var isActive = index === lastActiveIndex;
        var isSecondClick = isActive && lastClickedIndex === index;

        if (isSecondClick) {
          // Allow default navigation to the collection page
          return;
        }

        e.preventDefault();
        lastClickedIndex = index;
        var target = sections[index];
        if (target) {
          setActive(wrapper, navItems, discoverButton, index);
          target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
        }
      });
    });

    // Observe sections to set active
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = Number(entry.target.dataset.collectionIndex) || sections.indexOf(entry.target);
          if (idx !== lastActiveIndex) {
            lastClickedIndex = null; // reset so first click on new active item scrolls, second navigates
            lastActiveIndex = idx;
            setActive(wrapper, navItems, discoverButton, idx);
          }
        }
      });
    }, {
      threshold: 0.6,
      rootMargin: '0px 0px -30% 0px'
    });

    sections.forEach(function(section) {
      observer.observe(section);
    });

    // Observe wrapper to hide nav outside section
    if (navTargets.length) {
      navObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          setNavVisibility(entry.isIntersecting);
        });
      }, { threshold: 0.1 });

      navObserver.observe(wrapper);

      // Hide when bottom sentinel reaches viewport (approaching footer)
      bottomObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            setNavVisibility(false);
          } else {
            // Only show if wrapper is still intersecting
            var rect = wrapper.getBoundingClientRect();
            var inView = rect.bottom > 0 && rect.top < window.innerHeight;
            setNavVisibility(inView);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

      bottomObserver.observe(bottomSentinel);
    }

    // Center-sync fallback
    function syncOnScroll() {
      var viewportCenter = window.innerHeight / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;
      sections.forEach(function(section, idx) {
        var rect = section.getBoundingClientRect();
        var sectionCenter = rect.top + rect.height / 2;
        var distance = Math.abs(sectionCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = idx;
        }
      });
      if (closestIndex !== lastActiveIndex) {
        lastClickedIndex = null; // reset click state on active change
        lastActiveIndex = closestIndex;
        setActive(wrapper, navItems, discoverButton, closestIndex);
      }
    }

    window.addEventListener('scroll', syncOnScroll);
    window.addEventListener('resize', syncOnScroll);
    syncOnScroll();

    // Video control
    handleVideoPlayback(sections);

    // Expose cleanup
    wrapper.collectionsExplorerCleanup = function() {
      observer.disconnect();
      if (navObserver) navObserver.disconnect();
      if (bottomObserver) bottomObserver.disconnect();
      window.removeEventListener('scroll', syncOnScroll);
      window.removeEventListener('resize', syncOnScroll);
    };
  }

  /**
   * Auto init
   */
  document.addEventListener('DOMContentLoaded', function() {
    var wrappers = document.querySelectorAll('[id^="collections-explorer-"]');
    wrappers.forEach(function(wrapper) {
      var sectionId = wrapper.dataset.sectionId;
      if (sectionId) {
        initCollectionsExplorer(sectionId);
      }
    });
  });

  /**
   * Shopify editor support
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var wrapper = event.target.querySelector('[id^="collections-explorer-"]');
      if (wrapper) {
        var sectionId = wrapper.dataset.sectionId;
        if (wrapper.collectionsExplorerCleanup) wrapper.collectionsExplorerCleanup();
        setTimeout(function() { initCollectionsExplorer(sectionId); }, 50);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var wrapper = event.target.querySelector('[id^="collections-explorer-"]');
      if (wrapper && wrapper.collectionsExplorerCleanup) {
        wrapper.collectionsExplorerCleanup();
      }
    });
  }
})();
